export function variationDatasheetButton(selector = '.js-woo-variation-datasheet-btn') {
  const $btn = jQuery(selector);
  const $form = jQuery('form.variations_form');

  if (!$btn.length || !$form.length) return;

  $btn.hide();

  let datasheetsMap;
  try {
    datasheetsMap = JSON.parse($btn.attr('data-datasheets'));
  } catch (e) {
    console.error('Invalid datasheets JSON in', selector);
    return;
  }

  const hideButton = () => {
    $btn
      .removeAttr('href')
      .hide();
  };
  const showButton = (url) => {
    $btn
      .attr('href', url)
      .show();
  };
  const updateButtonForVariation = (variationId) => {
    if (variationId && datasheetsMap[variationId]) {
      showButton(datasheetsMap[variationId]);
    } else {
      hideButton();
    }
  };

  $form.on('found_variation', function (event, variation) {
    updateButtonForVariation(variation && variation.variation_id);
  });

  $form.on('reset_data', function () {
    hideButton();
  });

  // Trigger WooCommerce to re-check variations and fire found_variation if possible
  $form.trigger('check_variations');
}
